<template>
  <div class="ml-2 mr-2">
    <v-text-field class="input-text-size pa-0" label="Assessor Mill Code"
    v-model="editedItem.assessorTaxDistrictCode" />
    <!-- <v-text-field class="input-text-size pa-0 ma-0" label="Tax District Code"
    v-model="editedItem.taxDistrictCode" /> -->
    <CommonDropDowns class="input-text-size pa-0" :isItTaxDistrict=true
    @change="dataFromCommonDropDowns" :taxDistrictValue="editedItem.taxDistrictCode" />
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'assessorXRefDialog',
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'assessorXRef',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    dataFromCommonDropDowns(val, whichField) {
      if (whichField === 'taxDistrict') {
        this.editedItem.taxDistrictCode = val;
      } else this.editedItem[whichField] = val;
    },
  },
};
</script>
